import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useRef } from "react";

const ResizableContainer = ({
  children,
  index,
  width,
  minWidth,
  disableResizing,
  onResize,
  className,
}) => {
  const containerRef = useRef();
  const pivotRef = useRef();
  let startPos;
  let startWidth;

  const handleMouseMove = ({ clientX }) => {
    if (clientX < startPos) {
      const diff = startPos - clientX;
      const newWidth = startWidth - diff;
      onResize(index, newWidth > minWidth ? newWidth : minWidth);
    }
    if (clientX > startPos) {
      const diff = clientX - startPos;
      const newWidth = startWidth + diff;
      onResize(index, newWidth);
    }
  };

  const handleMouseUp = () => {
    document.body.classList.remove("col_resize_cursor");
    const container = containerRef?.current;
    if (container) {
      container.classList.remove("active");
    }
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const handleMouseDown = ({ clientX }) => {
    document.body.classList.add("col_resize_cursor");
    const container = containerRef?.current;
    if (container) {
      container.classList.add("active");
    }
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    startPos = clientX;
    startWidth = containerRef?.current?.clientWidth;
  };

  return (
    <span
      ref={containerRef}
      style={{ width }}
      className={clsx("resizable_container", className)}
      data-testid="resizable-container"
    >
      {children}
      {!disableResizing && (
        <div
          ref={pivotRef}
          onMouseDown={handleMouseDown}
          className="resizable_container__pivot_wrapper"
        >
          <div className="resizable_container__pivot_wrapper__pivot" />
        </div>
      )}
    </span>
  );
};

export default ResizableContainer;

ResizableContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  index: PropTypes.number.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  minWidth: PropTypes.number,
  disableResizing: PropTypes.bool,
  onResize: PropTypes.func.isRequired,
  className: PropTypes.string,
};
